<div class="modal-header">
    <div class="header-content">
        <h2 mat-dialog-title class="clean-title">{{ dialogTitle }}</h2>
        <span class="ref-badge"><i class="fa-solid fa-hashtag"></i> {{ data.rowData['v_ladings.alter'] || data.lading_uuid}}</span>
    </div>
</div>

<mat-dialog-content class="mat-typography custom-scroll no-pad-top">
    <div class="action-card">
        <div class="action-card-header">
        <i class="fa-solid fa-user-plus text-primary"></i> 
        <span>Edit Lading Status Note</span>
        </div>
        <form class="assign-section" [formGroup]="editForm" (ngSubmit)="saveNote()">
            <mat-form-field appearance="outline" class="tech-select flex-1">
                <mat-label>Note</mat-label>
                <input matInput formControlName="lading_status_note">
            </mat-form-field>
            <div class="form-actions right">
              <button mat-flat-button color="primary" class="shadow-sm btn-tall px-4" type="submit" [disabled]="editForm.invalid || saving">
                {{ saving ? 'Editing...' : 'Saved' }}
              </button>
            </div>
        </form>
    </div>
</mat-dialog-content>